// local development
// export const url = 'http://127.0.0.1:8000';

// aws cloud
export const url = 'https://aolhmserver.com';